<div style="padding-bottom: 20px;">
    <mat-accordion class="acordeon">
        <mat-expansion-panel #acordeon hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>Manuales y guías</h4>
                </mat-panel-title>
                <mat-panel-description>
                    <div> 
                        <label>3 DOCUMENTO(S)</label>    
                    </div>
                    <div>    
                        <mat-icon *ngIf="!acordeon.expanded">add_circle</mat-icon>
                        <mat-icon *ngIf="acordeon.expanded">remove_circle</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <table class="contenido-acordeon">
                <tr>
                    <td>Manual Modelo de Gestión de Calidad de la Educación Parvularia</td>
                    <td>
                        <a href="../../../../../assets/documentos/MANUAL DEL MODELO DE GESTIÓN DE CALIDAD DE LA EDUCACIÓN PARVULARIA.pdf" target="_blank" mat-raised-button class="btn-verDocumento"  >
                            Ver Documento
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>Guía de Autoevaluación Jardines Infantiles Clásicos</td>
                    <td>
                        <a href="../../../../../assets/documentos/GUÍA PROGRAMA EDUCATIVO JARDÍN INFANTIL.pdf" target="_blank" mat-raised-button class="btn-verDocumento">
                            Ver Documento
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>Guía de Autoevaluación Jardines Infantiles Alternativos</td>
                    <td>
                        <a href="../../../../../assets/documentos/GUIA PROGRAMA EDUCATIVO ALTERNATIVO.pdf" target="_blank" mat-raised-button class="btn-verDocumento">
                            Ver Documento
                        </a>
                    </td>
                </tr>
        </table>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<div style="padding-bottom: 20px;">
    <mat-accordion class="acordeon">
        <mat-expansion-panel  #acordeon2 hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>Lecturas complementarias</h4>
                </mat-panel-title>
                <mat-panel-description>
                    <div> 
                        <label>3 DOCUMENTO(S)</label>    
                    </div>
                    <div>    
                        <mat-icon *ngIf="!acordeon2.expanded">add_circle</mat-icon>
                        <mat-icon *ngIf="acordeon2.expanded">remove_circle</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <table class="contenido-acordeon">
                <tr>
                    <td>Bases Curriculares para la Educación Parvularia</td>
                    <td>
                        <a href="../../../../../assets/documentos/Bases Curriculares para la Educación Parvularia.pdf" target="_blank" mat-raised-button class="btn-verDocumento">
                            Ver Documento
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>Hacia un Sistema de Acreditación de Calidad</td>
                    <td>
                        <a href="../../../../../assets/documentos/Hacia un Sistema de Acreditación de Calidad.pdf" target="_blank" mat-raised-button class="btn-verDocumento">
                            Ver Documento
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>Marco para Buena Enseñanza de Educación Parvularia</td>
                    <td>
                        <a href="../../../../../assets/documentos/Marco para Buena Enseñanza de Educación Parvularia.pdf" target="_blank" mat-raised-button class="btn-verDocumento">
                            Ver Documento
                        </a>
                    </td>
                </tr>
            </table>

        </mat-expansion-panel>
    </mat-accordion>
</div>
<div>
    <mat-accordion class="acordeon">
        <mat-expansion-panel  #acordeon3 hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>Correos enviados</h4>
                </mat-panel-title>
                <mat-panel-description>
                    <div> 
                        <label>1 DOCUMENTO(S)</label>    
                    </div>
                    <div>    
                        <mat-icon *ngIf="!acordeon3.expanded">add_circle</mat-icon>
                        <mat-icon *ngIf="acordeon3.expanded">remove_circle</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            
            <table class="contenido-acordeon">
                <tr>
                    <td>CORREO N° 1 a jardines infantiles - Inicio proceso 7ma. aplicación del MGCEP</td>
                    <td>
                        <a href="../../../../../assets/documentos/CORREO N° 1 a jardines infantiles_ Inicio proceso 7ma. aplicación del MGCEP.pdf" target="_blank" mat-raised-button class="btn-verDocumento">
                            Ver Documento
                        </a>
                    </td>
                </tr>
            </table>
        </mat-expansion-panel>
    </mat-accordion>
</div>